<template>
    <div id="reader"
         class="full-size"
         :class="data.classReader"
         :style="data.styleReader"
         @click.prevent="onEmptyAreaClicked"
    >
        <Header :isLoadComplete="data.isLoadCompleted"
        ></Header>

        <pop-up v-if="bookInfoState.popupHtmlData || bookInfoState.popupImageData" ></pop-up>

        <div class="loading"
             v-if="!data.isLoadCompleted"
        >
            <img src="~images/loading.svg">
        </div>

        <div id="page-wrapper"
             class="no-select"
             :style="data.stylePageWrapper"
             v-if="pageState.isPageSizeReady"
             ref="refPageWrapper"
        >
            <div class="page-resize-panel no-select"
                 id="page-content-left"
                 :style="data.stylePageResizePanelLeft"
                 @click.prevent="closeIconMenu"
            >
                <div class="page-elements no-select"
                     id="page-elements-left"
                     :style="stylePageElements('left')"
                >
                    <pdf-image :side="'left'"></pdf-image>
                    <template v-for="i in pageState.pageCount" :key="i">
                        <tool-canvas class="canvas-left"
                                     :id="`tool-canvas-left-${i-1}`"
                                     v-show="isShowCanvasLeft(i-1)"
                                     :pagenum="i-1"
                        >
                        </tool-canvas>

                    </template>
                    <annotation-layer
                            v-if="parserState.annotData[pageState.currentPage[0]]"
                            :annot="parserState.annotData[pageState.currentPage[0]]"
                            :pagenum="pageState.currentPage[0]"
                    >
                    </annotation-layer>
                    <template v-for="i in pageState.pageCount" :key="i">
                        <note-container :side="'left'"
                                        :pagenum="i-1"
                                        v-show="isShowNoteContainerLeft(i-1)"

                        ></note-container>
                    </template>
                </div>
            </div>

            <div id="double-page-splitter"
                 v-show="pageState.isRightPageAvailable"
            >
            </div>

            <div class="page-resize-panel no-select"
                 id="page-content-right"
                 :style="data.stylePageResizePanelRight"
                 @click.prevent="closeIconMenu"
                 v-show="pageState.isRightPageAvailable"
            >
                <div class="page-elements no-select"
                     id="page-elements-right"
                     :style="stylePageElements('right')"
                >
                    <pdf-image :side="'right'"></pdf-image>
                    <template v-for="i in pageState.pageCount" :key="i">
                        <tool-canvas class="canvas-right"
                                     :id="`tool-canvas-right-${i-1}`"
                                     v-if="i % 2 === 0"
                                     v-show="isShowCanvasRight(i-1)"
                                     :pagenum="i-1"
                        >
                        </tool-canvas>
                    </template>
                    <annotation-layer :annot="parserState.annotData[pageState.currentPage[0]+1]"
                                      v-if="parserState.annotData[pageState.currentPage[0]+1]"
                                      :pagenum="pageState.currentPage[0]+1"
                    >
                    </annotation-layer>
                    <template v-for="i in pageState.pageCount" :key="i">
                        <note-container :side="'right'"
                                        :pagenum="i-1"
                                        v-if="i % 2 === 0"
                                        v-show="isShowNoteContainerRight(i-1)"
                        ></note-container>
                    </template>
                </div>
            </div>

            <double-page-zoom-control :side="'left'" v-show="pageState.isRightPageAvailable"></double-page-zoom-control>
            <double-page-zoom-control :side="'right'" v-show="pageState.isRightPageAvailable"></double-page-zoom-control>



        </div>

        <video-display v-if="bookInfoState.activeVideoData && bookInfoState.activeVideoData.type==='popup'">

        </video-display>

        <page-navigator v-show="data.isLoadCompleted"></page-navigator>
        <footer-reader :isLoadComplete="data.isLoadCompleted"></footer-reader>
        <p-panel v-if="data.isLoadCompleted"></p-panel>
        <bookmark-panel v-if="bookmarkState.isShow"></bookmark-panel>
        <div id="debug" v-html="data.debuglog"></div>
    </div>
</template>

<script>

    import {ref, reactive, onMounted, onUnmounted, onUpdated, watchEffect, watch, computed, nextTick, inject, toRaw}  from "vue";
    import {useRoute} from 'vue-router';
    import {useDataLoader} from "@/modules/reader/book/dataLoader";
    import {usePaging} from "@/modules/reader/book/paging";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import {useParser} from "@/modules/reader/annotations/parser";
    import {useAnnotationHelper} from "@/modules/reader/annotations/annotationHelper";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {useInlineExercise} from "@/modules/reader/inlineExercise/inlineExercise";
    import {useTool} from "@/modules/reader/tools/tools";
    import Header from "@/views/header/HeaderReader";
    import PPanel from "@/views/reader/ppanel/PPanel";
    import BookmarkPanel from "@/views/reader/bookmark/BookmarkPanel";
    import FooterReader from "@/views/footer/FooterReader";
    import PageNavigator  from "@/views/reader/PageNavigator";
    import PdfImage  from "@/views/reader/PdfImage";
    import AnnotationLayer  from "@/views/reader/annotations/AnnotationLayer";
    import DoublePageZoomControl from "@/views/reader/DoublePageZoomControl";
    import ToolCanvas from "@/views/reader/tool/drawing/ToolCanvas";
    import NoteContainer from "@/views/reader/tool/note/NoteContainer";
    import PopUp from "@/views/reader/popup/PopUp";
    import VideoDisplay from "@/views/reader/annotations/showResource/VideoDisplay";
    import config from "@/config/config.json";
    import {initDB} from "@/modules/localDB/localDB";
    import {getCurrentLocalHistory} from "@/modules/localDB/bookQuery";
    import cssvar from '@/scss/_variables.scss';
    import router from "@/router"
    import {useBookmark}  from "@/modules/reader/bookmark/bookmark";
    import {isTouchDevice, isIOS, deviceType} from "@/modules/utils/deviceUtils";
    import {isMultiTouch, replaceDefaultTouchBehavior, restoreDefaultTouchBehavior, setBodyPinchZoomOnly} from "@/modules/utils/touchUtils";
    import {toolState} from "../../modules/reader/tools/tools";

    const headerHeight = parseInt(cssvar.headerHeight);
    const doublePageSplitterWidth = parseInt(cssvar.doublePageSplitterWidth);
    const footerHeight = parseInt(cssvar.footerHeight)


    export default {
        components: {
            Header,
            FooterReader,
            PdfImage,
            PageNavigator,
            DoublePageZoomControl,
            AnnotationLayer,
            PopUp,
            ToolCanvas,
            NoteContainer,
            PPanel,
            BookmarkPanel,
            VideoDisplay
        },
        setup(props, context) {

            //The following values are used for swiping:
            let readerTouchStartX=0;
            let readerTouchStartY=0;
            let readerTouchStartTime=0; //time when reader element is just touched.
            let isMultiTouch = false; //used to detect if multi-touch to stop swiping if more than one finger
            let swipeDir = ""; //swipe direction

            const i18n = inject('i18n')
            const route = useRoute();
            const {bookData, fetchAll} = useDataLoader();
            const {pageState, setPageCount, setCurrentPage, togglePageMode} = usePaging();
            const {pageResizeState, zoomIn, zoomOut, zoomInLeftPage, zoomInRightPage, zoomOutLeftPage, zoomOutRightPage} = usePageResize();
            const {parserState} = useParser();
            const {currentPageAnnotationExtended} = useAnnotationHelper();
            const {bookInfoState, setDataFromConfig, closeSyncOptions} = useBookInfo();
            const {toolState, closeToolBoxAndPanel, getCanvas, restoreNoteHistory, restoreBrushHistory, setIsNoteDisabled} = useTool();
            const {bookmarkState, restoreBookmarkHistory} = useBookmark();
            const {goNextPage, goPrevPage} = usePaging();
            const {updateEntireBookAnswers} = useInlineExercise();

            const refPageWrapper = ref(null);
            const data = reactive({
                windowWidth: window.innerWidth,
                windowHeight:window.innerHeight,
                //isLocalRestored tells whether local history has been restored from web storage.
                isLocalRestored: false,
                //If the converted pdf images, annotations and local history are all done, the reader is ready to display
                isLoadCompleted: computed(() => {

                    if (toolState.isSyncProgress) {
                        return;
                    }

                    if (pageState.isPageSizeReady) {
                        if (data.isLocalRestored) {
                            if (pageState.isRightPageAvailable) {
                                if (parserState.annotData[pageState.currentPage[0]] && parserState.annotData[pageState.currentPage[0] + 1]) {
                                    return true;
                                }
                            } else {
                                if (parserState.annotData[pageState.currentPage[0]]) {
                                    return true;
                                }
                            }
                        }
                        return;
                    }
                    return;

                }),
                //Remark: since the page could be scrolled if zoomed in, the main page image top won't start under header when scrolled,
                //so add headerHeight so that the full main image can show up when reaching page bottom
                pageWrapperHeight: computed(() => {
                    return Math.round(pageResizeState.fittedBrowserHeight + headerHeight / pageResizeState.zoomLevel);
                }),
                stylePageWrapper: computed(() => {

                    let isDisplaySingle = pageState.pageMode === "single" || (pageState.isLastPage && !pageState.isRightPageAvailable);
                    //note that transform origin y  must be top, otherwise, the upper part cannot be seen if there is window vertical scroll bar
                    return {
                        height: `${data.pageWrapperHeight}px`,
                        width: isDisplaySingle ? `${pageResizeState.fittedBrowserWidth}px` : "auto",
                        //transform: (isDisplaySingle && !isTouchDevice()) ? `scale(${pageResizeState.zoomLevel }, ${pageResizeState.zoomLevel})` : "scale(1,1)",
                        transform: (isDisplaySingle ) ? `scale(${pageResizeState.zoomLevel }, ${pageResizeState.zoomLevel})` : "scale(1,1)",
                        transformOrigin: "top center",
                        display: isDisplaySingle ? "block" : "flex",
                    }

                }),
                styleReader: computed(() => {

                    //if (isTouchDevice()) {
                    if (deviceType() !== 'destkop') {
                        return {
                            width: "100%"
                        }
                    }
                    else {
                        if (pageResizeState.fittedBrowserZoomedWidth > data.windowWidth && !pageState.isRightPageAvailable) {

                            return {
                                width: `${pageResizeState.fittedBrowserZoomedWidth}px`,
                            }
                        } else {
                            return {
                                width: "100%",
                            }
                        }
                    }
                }),
                classReader: computed(()=>{
                    return {
                        "no-touch": !isTouchDevice()
                    }
                }),
                //pageResizePanelMaxWidth: (pageState.pageMode === "double" && pageState.isAllowTogglePageMode) ? `${data.windowWidth * 0.5}px` : "auto",
                pageResizePanelMaxWidth: computed(()=>{
                    return (pageState.isRightPageAvailable) ? `${data.windowWidth * 0.5 - doublePageSplitterWidth}px` : "auto"
                }),
                stylePageResizePanelLeft: computed(() => {
                    return {
                        //overflow: (!pageState.isRightPageAvailable || (pageState.isRightPageAvailable && pageResizeState.zoomLevelLeft * pageResizeState.fittedBrowserWidth <= (data.windowWidth - doublePageSplitterWidth) * 0.5)) ? "hidden" : "scroll",

                        //TODO: generalize in methods, don't repeat...
                        overflowY: (!pageState.isRightPageAvailable || (pageState.isRightPageAvailable && pageResizeState.zoomLevelLeft * pageResizeState.fittedBrowserHeight <= data.windowHeight) || toolState.isUsing) ? "hidden" : "scroll",
                        overflowX: (!pageState.isRightPageAvailable || (pageState.isRightPageAvailable && pageResizeState.zoomLevelLeft * pageResizeState.fittedBrowserWidth <= (data.windowWidth - doublePageSplitterWidth) * 0.5) || toolState.isUsing) ? "hidden" : "scroll",
                        width: data.pageResizePanelMaxWidth,
                        height: `${pageResizeState.fittedBrowserHeight}px`,
                        touchAction:(toolState.isUsing) ? "none": "auto"
                    }
                }),
                stylePageResizePanelRight: computed(() => {
                    return {
                        //TODO: generalize in methods, don't repeat...
                        overflowY: (!pageState.isRightPageAvailable || (pageState.isRightPageAvailable && pageResizeState.zoomLevelRight * pageResizeState.fittedBrowserHeight <= data.windowHeight) || toolState.isUsing) ? "hidden" : "scroll",
                        overflowX: (!pageState.isRightPageAvailable || (pageState.isRightPageAvailable && pageResizeState.zoomLevelRight * pageResizeState.fittedBrowserWidth <= (data.windowWidth - doublePageSplitterWidth) * 0.5) || toolState.isUsing) ? "hidden" : "scroll",
                        width: data.pageResizePanelMaxWidth,
                        height:`${pageResizeState.fittedBrowserHeight}px`,
                        touchAction:(toolState.isUsing) ? "none": "auto"
                    }
                }),
                leftPageOffsetLeft:"auto:", //the css left property for the page-elements-left div; used for positioning when browser scales / zoom level changes in double page mode
                annotations: [],
                isBodyScrolled: false, //tell whether browser window has been scrolled
                //isSwipable: isTouchDevice(), //tell whether swipe to turn page is allowed.
                isPanning:false, //tell whether the page container is being panned
                debuglog: "",
                hasSwipeListener:false
            });

            const stylePageElements = (side) => {

                let style;

                if (pageState.isRightPageAvailable) {

                    let zoomLevel = (side === "left") ? pageResizeState.zoomLevelLeft : pageResizeState.zoomLevelRight;

                    style = {
                        display: "flex",
                        width: `${pageResizeState.fittedBrowserWidth}px`,
                        height: `${pageResizeState.fittedBrowserHeight}px`,
                        transform: `scale(${zoomLevel}, ${zoomLevel})`,
                        //transformOrigin:(side === "left")? `0 ${headerHeight}px` : "0 0",
                        transformOrigin:"0 0",
                        position: "absolute"
                    }

                    //apply position left property for the left side only, since the page aligns with the left side of the browser naturally,
                    //move it so that it can reside next to the double-page-splitter
                    if (side === "left") {
                        style = {
                            ...{
                                left: data.leftPageOffsetLeft === "auto" ?  data.leftPageOffsetLeft  : `${data.leftPageOffsetLeft}px`
                            },
                            ...style
                        }
                    }

                } else {
                    style = {
                        width: `${pageResizeState.fittedBrowserWidth}px`,
                        margin: "0 auto",
                        height: `${pageResizeState.fittedBrowserHeight}px`
                    }
                }

                return style;
            }

            const readerOnResized = (e) => {
                data.windowWidth = window.innerWidth;
                data.windowHeight = window.innerHeight;
                nextTick(()=>{
                    updateLeftPagePos();
                })
                controlPageModeToggleOnResize();
                if (pageState.currentPage) {
                    setIsNoteDisabled()
                }
            }

            /**
             * Update the page content position of the left side in double page mode.
             * Since left/right margins may exist if browser is wide enough, set left offset so that the left page content
             * can reside next to the double-page-splitter.
             */
            const updateLeftPagePos = ()=>{
                //note that clientWidth is used because vertical scroll bar can exist. Otherwise, the page will be trimmed!
                if (document.getElementById(("page-content-left")).clientWidth > pageResizeState.zoomLevelLeft * pageResizeState.fittedBrowserWidth) {
                    data.leftPageOffsetLeft = document.getElementById(("page-content-left")).clientWidth - pageResizeState.zoomLevelLeft * pageResizeState.fittedBrowserWidth;
                } else {
                    data.leftPageOffsetLeft = "auto"
                }
            }

            /**
             * Determine whether page mode toggle should be allowed or not, and update page mode display when browser is resized.
             */
            const controlPageModeToggleOnResize = () => {

                //#page-elements-left could be undefined if not ready
                if (!document.querySelector("#page-elements-left")) {
                    return;
                }

                //check if window size is wide enough (see config.doublePageMinWinWidth) to comfortably view in double page mode
                if (window.innerWidth < config.reader.doublePageMinWinWidth || (isTouchDevice() && window.innerWidth  < window.innerHeight)) {
                    pageState.isAllowTogglePageMode = false;
                    if (pageState.pageMode === "double") {
                        pageState.activeDoublePage = pageState.currentPage;
                        togglePageMode();
                    }
                } else {
                    pageState.isAllowTogglePageMode = true;
                    if (pageState.activeDoublePage) {
                        togglePageMode();
                        pageState.activeDoublePage = null;
                    }
                }
            }

            //TODO: clean by generalizing the following similar methods...
            const isShowCanvasLeft = (pageIndex) => {
                return pageState.currentPage[0] === pageIndex;
            }

            const isShowCanvasRight = (pageIndex) => {
                return pageState.currentPage.includes(pageIndex)
            }

            const isShowNoteContainerLeft = (pageIndex) => {
                return pageState.currentPage[0] === pageIndex;
            }

            const isShowNoteContainerRight = (pageIndex) => {
                return pageState.currentPage.includes(pageIndex)
            }

            /**
             * Close any opened icon menu if other empty area of the page is clicked
             */
            const onEmptyAreaClicked = (e) => {

                console.log("onEmptyAreaClicked")
                console.log(e.target)
                console.log(e.currentTarget);

                let toolOptionPanelId = `${toolState.activeTool}-tool-options`;

                if (e.target.id  && e.target.id === "reader") {
                    closeIconMenu();
                }
                //don't close tool box panel if the target is the tool box option buttons
                else if (
                     e.target.tagName.toLowerCase() !== "a" &&
                    !e.target.classList.contains("btn-main-func") &&
                    !(document.getElementById(toolOptionPanelId) && document.getElementById(toolOptionPanelId).contains(e.target))
                ) {
                    closeIconMenu();
               //close icon menu if header footer is clicked
                }  else if (
                    !(document.getElementById(toolOptionPanelId) && document.getElementById(toolOptionPanelId).contains(e.target)) &&
                    !e.target.classList.contains("btn-main-func") &&
                    (document.querySelector("#header").contains(e.target) || document.querySelector("#footer").contains(e.target)))
                {
                    closeIconMenu();
                } else {
                    return false;
                }

            }

            /**
             * Close the attched menu options over the header /footer icons
             */
            const closeIconMenu = ()=>{
                closeToolBoxAndPanel();
                closeSyncOptions();
            }

            const onBodyScrolled = (e) => {
                data.isBodyScrolled = true;
            }


            const swipeLeft = () => {
                nextTick(() => {
                    //video control sliding will conflict with swipe, so disable swipe if video is active
                    if (bookInfoState.activeVideoData) {
                        return;
                    }
                    if (!pageState.isLastPage && !toolState.isAllowed) {
                        goNextPage();
                    }
                });
            }

            const swipeRight = () => {
                nextTick(() => {
                    //video control sliding will conflict with swipe, so disable swipe if video is active
                    if (bookInfoState.activeVideoData) {
                        return;
                    }
                    if (!pageState.isFirstPage && !toolState.isAllowed) {
                        goPrevPage();
                    }
                });
            }

            const addSwipeListeners = ()=>{
                //addSwipeListeners will be called continuously if the two fingers stay on the screen and keep scaling down, so use hasSwipeListener to avoid
                if (data.hasSwipeListener) {
                    return;
                }
                data.hasSwipeListener = true;
                //data.isSwipable = true;
                if (document.querySelector("#reader")) {
                    document.querySelector("#reader").addEventListener("touchstart", onReaderTouchStart);
                    document.querySelector("#reader").addEventListener("touchend", onReaderTouchEnd);
                }
            }

            const removeSwipeListeners = ()=>{
                //data.isSwipable = false;
                data.hasSwipeListener = false;
                if (document.querySelector("#reader")) {
                    document.querySelector("#reader").removeEventListener("touchstart", onReaderTouchStart);
                    document.querySelector("#reader").removeEventListener("touchend", onReaderTouchEnd);
                }
            }


            const onReaderTouchStart = (e)=>{
                //e.preventDefault();
                //if (data.isSwipable) {
                    swipeDir = "";
                    readerTouchStartX = e.changedTouches[0].pageX;
                    readerTouchStartY = e.changedTouches[0].pageY;
                    readerTouchStartTime = new Date().getTime();
                //}
            }

            const onReaderTouchEnd = (e)=>{
                //e.preventDefault();

                //swipe only if the touch is targeted on the main book content area:
                if ((e.target.id && e.target.id.indexOf("playspan") >= 0) || e.target.classList.contains("canvas-left") || e.target.classList.contains("canvas-right") || ( e.target.id &&  e.target.id === "reader")) {

                    //document.getElementById("debug").innerHTML += e.touches.length + " ; " + e.targetTouches.length + " ; " + e.changedTouches.length + "<br>"

                    //it's detected that e.touches.length is zero if more than one finger, in most cases it will be:
                    //first time  e.touches.length=1, e.targetTouches.length=1, e.changedTouches.length=1
                    //second time e.touches.length=0, e.targetTouches.length=0, (e.changedTouches.length=1 or e.changedTouches.length=2)
                    //if only single touch , then always:
                    //e.touches.length=0, e.targetTouches.length=0, e.changedTouches.length=1
                    //So we detect multi-touch if e.changedTouches.length > 1 or e.touches.length=1:
                    if (isMultiTouch && !e.touches.length) {
                        isMultiTouch = false;
                        return;
                    }

                    if (e.touches.length > 1 || e.touches.length !== 0) {
                        isMultiTouch = true;
                        return;
                    }

                    let distX = e.changedTouches[0].pageX - readerTouchStartX
                    let distY = e.changedTouches[0].pageY - readerTouchStartY
                    let elapsedTime = new Date().getTime() - readerTouchStartTime
                    if (elapsedTime <= config.reader.swipeAllowedTime) {
                        if (Math.abs(distX) >= config.reader.swipeThreshold && Math.abs(distY) <= config.reader.swipeRestraint) {
                            swipeDir = (distX < 0) ? "left" : "right"
                            if (swipeDir === "left") {
                                swipeLeft();
                            } else if (swipeDir === "right") {
                                swipeRight();
                            }
                        } else if (Math.abs(distY) >= config.reader.swipeThreshold && Math.abs(distX) <= config.reader.swipeRestraint) {
                            swipeDir = (distY < 0) ? "up" : "down"
                        }
                    }
                }

            }

            const onViewportScaled = (e)=>{

                if (e.target.scale === 1) {
                    addSwipeListeners();
                } else {
                    removeSwipeListeners();
                }

            }

            onMounted(()=>{
                nextTick(()=>{
                    //add a timeout to avoid null context on tablet during local restore....
                    onReady();
                })
            })

            onUnmounted(()=>{

                window.visualViewport.removeEventListener("resize", onViewportScaled);
                removeSwipeListeners();
                window.removeEventListener("resize",readerOnResized);
            })

            const onReady = async ()=>{

                console.log("process.env:");
                console.log(process.env)

                //TODO: handle if no ebooklist (i.e. no permission)
                useBookInfo().reset();

                let ebookcode = route.query.ebookcode;
                let ebooklist = JSON.parse(localStorage.ebooklist);

                for (let item of ebooklist) {
                    for (let book of item.ebooks) {
                        if (book.ebookcode === ebookcode) {
                            let ebookname = book.ebookmodulename;
                            let ebookdownloadpath = book.ebookfileurl;
                            let gradecode = book.ebookusedgradescode;
                            let subjectcode = item.subjectcode;
                            let ebookIdPermissionPath = decodeURIComponent(ebookdownloadpath.split("file?p=")[1]);

                            bookInfoState.ebookname = ebookname; //jp version uses this
                            bookInfoState.publicPath = `${process.env.VUE_APP_EBOOK_PUBLIC_PATH}${ebookIdPermissionPath}`;
                            bookInfoState.ebookDownloadPath = ebookdownloadpath;
                            bookInfoState.gradecode = gradecode;
                            bookInfoState.subjectcode = subjectcode;

                            //Use local working folder for testing if you would like to do so, otherwise, remove the following if block and use dev remote one.
                            if (process.env.VUE_APP_MODE === "local") {
                                bookInfoState.publicPath = 'dist/' + ebookIdPermissionPath;
                                bookInfoState.ebookDownloadPath = 'dist/' + ebookIdPermissionPath;
                            //dev and uat is temporarily changed to use mpms produciton api, but expected to load staging server books, which require access token checking with ebook download path api.
                            //Here just use the direct link to avoid token checking. remove the following block if reverted to use  dev mpms login again!
                            } else if (process.env.VUE_APP_MODE === "dev" || process.env.VUE_APP_MODE === "staging") {
                                bookInfoState.publicPath =  "https://dev.hkep.com/ireader/uploads/" +  ebookIdPermissionPath;
                                bookInfoState.ebookDownloadPath = "https://dev.hkep.com/ireader/uploads/" + ebookIdPermissionPath;
                            } else {
                                bookInfoState.ebookDownloadPath = `${process.env.VUE_APP_EBOOK_PUBLIC_PATH}${ebookIdPermissionPath}`;

                            }
                        }
                    }
                }

                try {

                    if (!bookInfoState.ebookDownloadPath) {
                        throw new Error("error_fetch_data")
                    }

                    let fetchJsonPath = (process.env.VUE_APP_MODE === "release" || process.env.VUE_APP_MODE === "releaseuat") ?  bookInfoState.ebookDownloadPath.replace("ebook_package/book", "getebook/file?p=/book") : bookInfoState.ebookDownloadPath;
                    await fetchAll(fetchJsonPath);
                    setPageCount(bookData.annotations.length);
                    setDataFromConfig(bookData.config);
                    await initDB(ebookcode);
                    let localHistory = await getCurrentLocalHistory();
                    let queryTargetPageIndex = -1;
                    console.log("localHistory db record:");
                    console.log(localHistory);

                    if (router.currentRoute.value.query.page) {
                        queryTargetPageIndex = bookData.pagenames.indexOf(router.currentRoute.value.query.page);
                        if (queryTargetPageIndex === -1) {
                            queryTargetPageIndex = 0;
                        }
                    }

                    //if there is no local history, the book should be opened the first time, set first page as current page in this case:
                    if (!localHistory) {
                        if (queryTargetPageIndex >= 0) {
                            await setCurrentPage(queryTargetPageIndex);
                        } else {
                            await setCurrentPage(0);
                        }
                        data.isLocalRestored = true;
                    } else {
                        if (queryTargetPageIndex >= 0) {
                            await setCurrentPage(queryTargetPageIndex);
                        } else {
                            await setCurrentPage(localHistory.lastRead);
                        }

                        if (localHistory.toolHistory) {

                            for (let [page, history] of Object.entries(localHistory.toolHistory)) {
                                //note that pagenum from the local history is not zero-based, so minus one for getCanvas, which uses zero-based

                                let pagenum = parseInt(page) - 1;
                                restoreBrushHistory(document.getElementById(`tool-canvas-left-${pagenum}`), history, pagenum);
                                restoreNoteHistory(history, pagenum);

                                //pagenum is now zero-bsed and all even number page should have right-hand-side canvas to restore:
                                if (pagenum % 2 === 1) {
                                    restoreBrushHistory(document.getElementById(`tool-canvas-right-${pagenum}`), history, pagenum);
                                }
                            }
                        }

                        if (localHistory.bookmark) {
                            restoreBookmarkHistory(localHistory.bookmark);
                        }


                        if (localHistory.inlineExercise) {
                            updateEntireBookAnswers(localHistory.inlineExercise);
                        }

                        data.isLocalRestored = true;
                    }

                    //nextTick(() => {

                        if (isTouchDevice()) {

                            addSwipeListeners();

                            window.addEventListener("orientationchange", (e)=>{
                                //if viewport is scaled and orientation is changed, address bar will be hidden in safari causing height problem, just refresh to resolve..
                                if (isIOS()) {
                                    location.reload();
                                    return;
                                }
                                window.scrollTo(0,0);
                                let originalBodyStyle = getComputedStyle(document.body).getPropertyValue('display');
                                document.body.style.display='none';
                                setTimeout(()=> {
                                    readerOnResized();
                                    document.body.style.display = originalBodyStyle;
                                }, 200);
                            });

                            readerOnResized();
                            window.visualViewport.addEventListener("resize", onViewportScaled);

                        } else {

                            window.addEventListener("resize",readerOnResized);
                            document.querySelector("body").addEventListener("scroll", onBodyScrolled);
                        }
                   // });

                    //console.log(bookData)
                    //console.log(parserState.annotData)

                } catch (error) {
                    //TODO: popup
                    console.log("ERROR OCCURRED:")
                    console.log(error.message)
                    console.log(error.stack)

                    alert(i18n.t(error.message))

                    if (error.message === "info_msg_book_coming") {
                        router.push("home");
                    }
                }

            }

            watch(
                () => data.styleReader.width,
                (newVal, oldVal) => {
                    //attempt to position the reader div to the middle of the browser, unless the window is scrolled by user.
                    nextTick(() => {
                        //reader width is 100% if it doesn't exceed window width, otherwise, it comes with values in pixels,
                        //if change from 100% to pixel value, the width should exceed browser window, then attempt to position reader to center. Do also if no scrolling by user
                        if (oldVal === "100%" || !data.isBodyScrolled) {
                            document.querySelector("body").scrollLeft = (pageResizeState.fittedBrowserZoomedWidth - document.body.clientWidth) * 0.5;
                        } else if (newVal === "100%") {
                            data.isBodyScrolled = false;
                        }
                    })
                }
            )

            /**
             * Watch zoomLevelLeft here instead of watchEffect since updateLeftPagePos will change reactive data,
             * causing watchEffect keeps listening when during pinch zoom left page
             */
            watch(
                () =>  pageResizeState.zoomLevelLeft,
                (newVal, oldVal) => {
                    nextTick(()=> {
                        if (pageState.isRightPageAvailable) {
                            updateLeftPagePos();
                        }
                    });
                }
            )

            watch(
                () =>  pageState.isRightPageAvailable,
                (newVal, oldVal) => {
                    if (newVal === true && pageResizeState.zoomLevelLeft === 1) {
                        nextTick(()=> {
                            updateLeftPagePos();
                        })
                    }
                }
            )

            watchEffect(()=> {

                //if tool is being used, disable browser pinch zoom gesture by updating <body> touch-action property
                /*
                if (toolState.isUsing) {
                    replaceDefaultTouchBehavior();
                } else {
                    restoreDefaultTouchBehavior();
                }
                /*
                //adding nextTick will avoid watchEffect from firing multiple times!
                if (data.isLoadCompleted && data.isLocalRestored) {
                    if (isTouchDevice()) {
                        if (toolState.isUsing) {
                            nextTick(()=> {
                                removePinchPanListener();
                                document.addEventListener("touchmove", documentOnTouchMove);
                                if (pageState.isRightPageAvailable) {
                                    document.querySelector("#page-content-left").style.overflow = "hidden";
                                    document.querySelector("#page-content-right").style.overflow = "hidden";
                                    document.querySelector("body").style.touchAction = "none";
                                } else {
                                    let winScrollLeft = document.querySelector("body").scrollLeft;
                                    let winScrollTop = document.querySelector("body").scrollTop;
                                    document.querySelector("body").style.touchAction = "none";
                                    document.querySelector("body").style.overflow = "hidden";
                                    window.scrollTo(winScrollLeft, winScrollTop);
                                }
                                return;
                            });
                        } else {
                            //when panning occurs, do not watch changes that may affect touch behaviors
                            if (!data.isPanning || !toolState.activeNote) {
                                nextTick(()=> {
                                    //data.debuglog += "not panning or no active note <br>"
                                    if (pageState.isRightPageAvailable) {
                                        document.querySelector("#page-content-left").style.overflow = "scroll";
                                        document.querySelector("#page-content-right").style.overflow = "scroll";
                                        document.querySelector("body").style.touchAction = "pan-x pan-y";
                                    } else {
                                        //if tool is just turned off, and page is zoomed in and body height is set , the page should be scrollable, then allow auto overflow
                                        if (document.querySelector("body").style.height !== "auto") {
                                            document.querySelector("body").style.overflow = "auto";
                                            //otherwise, the page should be not zoomed in, and keep the body overflow hidden
                                        } else {
                                            document.querySelector("body").style.overflow = "hidden";
                                        }
                                        document.querySelector("body").style.touchAction = "pan-x pan-y";
                                    }
                                });
                            }
                        }

                        nextTick(()=> {
                            //critical! update body height so that the page can be scrolled on touch device
                            document.querySelector("body").style.height = data.pageWrapperHeight * pageResizeState.zoomLevel + "px"

                            //if landscape mode, when page width exceeds browser width, or
                            //if portrait mode, when zoomed in, disable swipe gesture since it conflicts with panning
                            if (pageResizeState.fittedBrowserZoomedWidth > window.innerWidth && window.innerWidth > window.innerHeight ||
                                pageResizeState.zoomLevel > 1 && window.innerWidth < window.innerHeight
                            ) {
                                removeSwipeListeners();
                            } else {
                                addSwipeListeners();
                            }
                        })
                    }
                }
                */
            });

            return {
                data,
                refPageWrapper,
                bookData,
                fetchAll,
                pageState,
                parserState,
                bookInfoState,
                bookmarkState,
                currentPageAnnotationExtended,
                toolState,
                setPageCount,
                setCurrentPage,
                setDataFromConfig,
                closeIconMenu,
                stylePageElements,
                isShowCanvasLeft,
                isShowCanvasRight,
                isShowNoteContainerLeft,
                isShowNoteContainerRight,
                onEmptyAreaClicked,
                isTouchDevice,
                deviceType,
                PopUp
            }
        }
    }
</script>

<style lang="scss">

    #reader, html{
        background:$grey-light;
    }

    #page-wrapper {
        position:relative;
        top:$header-height;
        margin:0 auto;
        justify-content: center;
    }

    .page-resize-panel {
        position:relative;
        display:flex;
    }

    .page-elements {
        height:100%;
        transform-origin:top left;
        flex:1;
    }

    #page-content-left {
        /*justify-content: flex-end;*/
    }

    #double-page-splitter {
        width:$double-page-splitter-width;
        height:100%;
        background:$border-color-light;
    }

    .loading {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 0;
        width:100%;
        top: $header-height;
        z-index:$zindex-reader-loading;
        background: $grey-light;
        height:calc(100% - #{$header-height} - #{$footer-height})
    }

    #debug {
        position:fixed;
        left:0;
        top:50px;
        z-index:1000;
        background:rgba(255, 255, 255, 0.7);
        height:500px;
        overflow:scroll;
        width:250px;
        color:#ff0000;
        font-size:12px;
        border:1px solid #00d4ff;
        display:none;
        text-align:right;
    }
</style>